export default __webpack_public_path__ + "assets/images/94511da14809644bc945b9d290d5f55c.png";